export const isTruthyValue = <T>(value: T): value is NonNullable<T> => !!value;
